import React from 'react';
import { Link } from 'react-router-dom';
import { BrandSymbol } from './BrandSymbol';
type LogoProps = {
  tone?: 'dark' | 'light';
  className?: string;
};

/** tone="dark" is for dark backgrounds; tone="light" for light backgrounds. */
export function Logo({
  tone = 'dark',
  className = ''
}: LogoProps) {
  const word = tone === 'dark' ? 'text-white' : 'text-midnight';
  const sub = tone === 'dark' ? 'text-gold-300' : 'text-gold-700';
  return <Link to="/" aria-label="Corventa Talent Search — home" className={`group inline-flex items-center gap-3 ${className}`} data-id="element-46" data-mp="u1nh2zoiacgu">
      <BrandSymbol size={38} tone={tone} className="shrink-0" data-id="element-47" data-mp="13xqke8v3gh5d" />
      <span className="flex flex-col leading-none" data-id="element-48" data-mp="13wff24m031c5">
        <span className={`font-display text-[26px] font-semibold tracking-[0.04em] ${word}`} data-id="element-49" data-mp="18xcx8h70fvdn">Corventa</span>
        <span className={`mt-1 text-[9.5px] font-medium uppercase tracking-[0.34em] ${sub}`} data-id="element-50" data-mp="2fdoumg20d986">Talent Search</span>
      </span>
    </Link>;
}